<table class="lists-chat sticky-table-first" *ngIf="(isMobile == false || isMobile && type == 1)" style="padding: 30px;">
    <thead>
        <tr>
            <th *ngFor="let detal of title let i = index" 
                [style]="detal.css" 
                [ngClass]="{
                    'sorting': detal.sort,
                    'sorting_asc': sort_obj.column === content[i].title && sort_obj.sort === '0',
                    'sorting_desc': sort_obj.column === content[i].title && sort_obj.sort !== '0'
                }">
                <ng-container *ngIf="detal.sort; else notSortable">
                    <span (click)="sort_fn(content[i].title, sort_obj.sort)">
                        {{ detal.title }}
                    </span>
                </ng-container>
                <ng-template #notSortable>
                    {{ detal.title }}
                </ng-template>
            </th>
        </tr>
    </thead>
    <tbody>
        <tr *ngFor="let dataitem of data">
            <td *ngFor="let item of content" [style]="item.css" >
                <div *ngIf="item.type == 1">
                    <img  [src]="dataitem[item.title]" alt="" style="width: 30px;">    
                </div> 

                <div *ngIf="item.type == 2">
                    <app-userandactive  [post]="dataitem"></app-userandactive>
                </div> 
                
                <div *ngIf="item.type == 3"  [innerHTML]="dataitem[item.title]"></div> 

                <div *ngIf="item.type != 1 && item.type != 2  && item.type != 3 && item?.model != 1  && item?.model != 2" >
                    {{ dataitem[item.title] | dynamicFormat:item?.format }}
                </div>  
                
                <div *ngIf="item?.model == 1">
                    <a href="javascript:void(0)" (click)="handleClick(dataitem.name)">{{ dataitem[item.title] | dynamicFormat:item?.format }}</a>
                </div>
                <div *ngIf="item?.model == 2" [innerHTML]="custom" (click)="handleClick(dataitem)"></div>
            </td>
        </tr>
    </tbody>
</table>


<div *ngIf="isMobile && type == 2">
    <div *ngIf="shouldShowMobileSortPanel()" class="mobile-sort-panel">
        <div class="sort-type">
            <select [(ngModel)]="selectedSortType" (change)="cardsort_fn(selectedSortType, selectedSortOrder)">
                <option default disabled value="-1">請選擇排序名稱</option>
                <ng-container *ngFor="let detal of title">
                    <option *ngIf="detal.sort" [value]="detal.sort">{{ detal.title }}</option>
                </ng-container>
            </select>
        </div>
        <div class="sort-order">
            <select [(ngModel)]="selectedSortOrder" (change)="cardsort_fn(selectedSortType, selectedSortOrder)">
                <option default disabled value="-1">請選擇排序順序</option>
                <option value="0">由高到低</option>
                <option value="1">由低到高</option>
            </select>
        </div>
    </div>


    <div class="container-fluid">
        <div class="row">
            <div class="col-12">
                <div class="card">
                    <div class="card-body" *ngIf="data.length > 0">
                        <div *ngFor="let item of data let i = index" class="row mb-3">
                            <div class="col-6">
                                <div class="card">
                                    <div class="card-body">
                                        <div class="d-flex align-items-center" *ngFor="let titledetail of title let is = index">
                                            <h5 class="card-title mb-2">{{titledetail.title}}:</h5>
                                            <div *ngIf="content[is].type == 1">
                                                <img  [src]="item[content[is].title]" alt="" style="width: 30px;margin-left: 10px;">    
                                            </div>
                                            <div *ngIf="content[is].type == 2" style="margin-left: 10px;">
                                                <app-userandactive  [post]="item"></app-userandactive>    
                                            </div>
                                            <div *ngIf="content[is].type == 3" style="margin-left: 10px;" [innerHTML]="item[content[is].title]"></div>
                                            <div *ngIf="content[is].type != 1 && content[is].type != 2 && content[is].type != 3  && content[is]?.model != 1">
                                                <p class="card-text mb-2 ml-3">{{item[content[is].title] | dynamicFormat:content[is].format}}</p>
                                            </div>
                                            <div *ngIf="content[is]?.model == 1">
                                                <a href="javascript:void(0)" (click)="handleClick(item.name)">{{item[content[is].title] | dynamicFormat:content[is].format}}</a>
                                            </div>
                                            <div *ngIf="content[is]?.model == 2" [innerHTML]="custom" (click)="handleClick(item)"></div>
                                        </div>   
                                    </div>
                                </div>
                            </div>
                            <!-- 你可以根據需要添加更多的列 -->
                        </div>
                    </div>
                    <div *ngIf="!data.length || data.length == 0" class="no-data text-center mt-4">無資料</div>
                </div>
            </div>
        </div>
        <a *ngIf="showbacktop" (click)="go_top()" id="go_top" onclick="return false" class="back-to-top"> <i style="font-size: 1.73em;" class="fas fa-arrow-circle-up"></i> </a>
    </div>
</div>